import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["accept"]
const _hoisted_2 = {
  class: "file-label",
  for: "uploadFiles"
}
const _hoisted_3 = { class: "input-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "file-list-container" }
const _hoisted_10 = { class: "card-content" }
const _hoisted_11 = { class: "break-all" }
const _hoisted_12 = { class: "file-size" }

import { ref, computed, watch } from 'vue';
import { CloudArrowUpIcon, XMarkIcon, DocumentPlusIcon } from '@heroicons/vue/24/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilesUpload',
  props: ['labelText', 'preselectedFiles','acceptExtensions','acceptText'],
  emits: ['filesToUpload'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;

const isDragging = ref(false);

const savedFiles = computed(()=> props.preselectedFiles ? [...props.preselectedFiles] : []);

const filesToUpload = ref(savedFiles.value);

const getFiles = (e) => {
    filesToUpload.value = !filesToUpload.value.length ? [...e.target.files] : [...filesToUpload.value, ...e.target.files];
    emit('filesToUpload', filesToUpload.value)
};
const dragover = (e:Event) => {
    e.preventDefault();
    isDragging.value = true;
}
const dragleave = () => isDragging.value = false;
const drop = (e) => {
    e.preventDefault();
    filesToUpload.value = !filesToUpload.value.length ? [...e.dataTransfer.files] : [...filesToUpload.value, ...e.dataTransfer.files];
    isDragging.value = false;
    emit('filesToUpload', filesToUpload.value)
}
const removeFile = (i: number) => {
    filesToUpload.value.splice(i, 1);
    emit('filesToUpload', filesToUpload.value)
}

watch(savedFiles, (newSavedFiles) => {
  filesToUpload.value = newSavedFiles.length > 0 ? newSavedFiles : [];
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "dropzone-container",
      onDragover: dragover,
      onDragleave: dragleave,
      onDrop: drop
    }, [
      _createElementVNode("input", {
        type: "file",
        multiple: "",
        name: "uploadFiles",
        class: "hidden-input",
        id: "uploadFiles",
        onChange: getFiles,
        accept: __props.acceptExtensions ?? '.pdf,.txt,.csv,.doc,.docx,.ppt,.pptx,.xsl,.xlsx,.png,.jpg,.jpeg,.gif,.bmp,.webp'
      }, null, 40, _hoisted_1),
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(CloudArrowUpIcon), { class: "icon icon-small icon-upload" }),
          (isDragging.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Release to drop files here."))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("p", null, [
                  _createTextVNode("Drop files here or "),
                  _createElementVNode("u", null, "click here"),
                  _createTextVNode(" to upload.")
                ], -1)),
                _createElementVNode("span", null, _toDisplayString(__props.acceptText ?? "PDF, TXT, CSV, DOC, PPT, XLS, PNG, JPG or GIF"), 1)
              ]))
        ])
      ])
    ], 32),
    (filesToUpload.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (__props.labelText)
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(__props.labelText), 1))
            : (_openBlock(), _createElementBlock("label", _hoisted_8, "Selected Files")),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesToUpload.value, (file, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "upload-file-preview"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(DocumentPlusIcon), { class: "icon thick icon-file add" }),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(file.name), 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(Math.round(file.size / 1000) + "kb"), 1)
                  ])
                ]),
                _createVNode(_unref(XMarkIcon), {
                  class: "icon icon-small shrink-0",
                  onClick: ($event: any) => (removeFile(index))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})